"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CreateInventoryAudit = /** @class */ (function () {
    function CreateInventoryAudit(json) {
        var _this = this;
        this.title = '';
        this.mappedProducts = new Map();
        this.getAuditProduct = function (productId) { return _this.mappedProducts.get(productId); };
        this.addAuditProduct = function (auditProduct) {
            var existingAuditProductRecord = _this.getAuditProduct(auditProduct.productId);
            if (existingAuditProductRecord) {
                return existingAuditProductRecord;
            }
            var newAuditProductRecord = new EditAuditProduct(auditProduct);
            _this.mappedProducts.set(auditProduct.productId, newAuditProductRecord);
            return newAuditProductRecord;
        };
        this.removeAuditProduct = function (productId) {
            _this.mappedProducts.delete(productId);
        };
        this.removeAllAuditProducts = function () {
            _this.mappedProducts = new Map();
        };
        this.populate(json);
    }
    CreateInventoryAudit.prototype.populate = function (json) {
        var _this = this;
        var products = json.products;
        delete json.products;
        Object.assign(this, json);
        products.forEach(function (p) { return _this.mappedProducts.set(p.productId, new EditAuditProduct(p)); });
    };
    Object.defineProperty(CreateInventoryAudit.prototype, "products", {
        get: function () {
            return __spread(this.mappedProducts.values());
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "title", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "companyId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "locationId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "locationName", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "startingUserId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "startingUserName", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "endingUserId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "endingUserName", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "notes", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "status", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "createDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "updateDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "completeDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "inventorySnapshotId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInventoryAudit.prototype, "mappedProducts", void 0);
    __decorate([
        mobx_1.action
    ], CreateInventoryAudit.prototype, "populate", null);
    __decorate([
        mobx_1.action
    ], CreateInventoryAudit.prototype, "addAuditProduct", void 0);
    __decorate([
        mobx_1.action
    ], CreateInventoryAudit.prototype, "removeAuditProduct", void 0);
    __decorate([
        mobx_1.action
    ], CreateInventoryAudit.prototype, "removeAllAuditProducts", void 0);
    __decorate([
        mobx_1.computed
    ], CreateInventoryAudit.prototype, "products", null);
    return CreateInventoryAudit;
}());
exports.CreateInventoryAudit = CreateInventoryAudit;
var EditAuditProduct = /** @class */ (function () {
    function EditAuditProduct(json) {
        var _this = this;
        this.mappedBatches = new Map();
        this.setBatches = function (batches) {
            batches.forEach(function (batch) { return _this.mappedBatches.set(batch.id, new EditAuditBatch(batch)); });
        };
        this.locallySaveEnteredQuantity = function (enteredQuantity) {
            _this.locallySavedEnteredQuantity = enteredQuantity;
        };
        this.locallySaveNotes = function (notes) {
            _this.locallySavedNotes = notes;
        };
        this.id = json.id;
        this.sku = json.sku;
        this.barcode = json.barcode;
        this.productId = json.productId;
        this.productName = json.productName;
        this.expectedQuantity = json.expectedQuantity;
        this.enteredQuantity = json.enteredQuantity;
        this.locallySavedEnteredQuantity = json.enteredQuantity;
        this.notes = json.notes;
        this.locallySavedNotes = json.notes;
        this.isBatchTracked = json.isBatchTracked;
        this.purchasePrice = json.purchasePrice;
        this.setBatches(json.batches);
    }
    EditAuditProduct.prototype.removeBatch = function (id) {
        this.mappedBatches.delete(id);
    };
    EditAuditProduct.prototype.addBatch = function (batch) {
        // Check if the new batch is already included in batches
        var existingAuditBatch = this.mappedBatches.get(batch.id);
        if (existingAuditBatch) {
            return existingAuditBatch;
        }
        var newBatch = new EditAuditBatch({
            id: batch.id,
            inventoryAuditProductId: batch.inventoryAuditProductId,
            batchId: batch.batchId,
            batchNumber: batch.batchNumber,
            expectedQuantity: batch.quantityRemaining,
            enteredQuantity: null,
        });
        this.mappedBatches.set(batch.id, newBatch);
        return newBatch;
    };
    EditAuditProduct.prototype.setEnteredQuantity = function (enteredQuantity) {
        this.enteredQuantity = enteredQuantity;
    };
    EditAuditProduct.prototype.setNotes = function (notes) {
        this.notes = notes;
    };
    Object.defineProperty(EditAuditProduct.prototype, "batchQuantitySum", {
        get: function () {
            return this.batches.reduce(function (prev, curr) { return prev + (curr.enteredQuantity || 0); }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditAuditProduct.prototype, "batches", {
        get: function () {
            return __spread(this.mappedBatches.values());
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "sku", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "barcode", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "productId", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "productName", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "expectedQuantity", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "enteredQuantity", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "locallySavedEnteredQuantity", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "notes", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "locallySavedNotes", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "updateDate", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "isBatchTracked", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "purchasePrice", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditProduct.prototype, "mappedBatches", void 0);
    __decorate([
        mobx_1.action
    ], EditAuditProduct.prototype, "removeBatch", null);
    __decorate([
        mobx_1.action
    ], EditAuditProduct.prototype, "addBatch", null);
    __decorate([
        mobx_1.action
    ], EditAuditProduct.prototype, "setBatches", void 0);
    __decorate([
        mobx_1.action
    ], EditAuditProduct.prototype, "setEnteredQuantity", null);
    __decorate([
        mobx_1.action
    ], EditAuditProduct.prototype, "locallySaveEnteredQuantity", void 0);
    __decorate([
        mobx_1.action
    ], EditAuditProduct.prototype, "setNotes", null);
    __decorate([
        mobx_1.action
    ], EditAuditProduct.prototype, "locallySaveNotes", void 0);
    __decorate([
        mobx_1.computed
    ], EditAuditProduct.prototype, "batchQuantitySum", null);
    __decorate([
        mobx_1.computed
    ], EditAuditProduct.prototype, "batches", null);
    return EditAuditProduct;
}());
exports.EditAuditProduct = EditAuditProduct;
var UpdateInventoryAudit = /** @class */ (function () {
    function UpdateInventoryAudit() {
    }
    __decorate([
        mobx_1.observable
    ], UpdateInventoryAudit.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], UpdateInventoryAudit.prototype, "add", void 0);
    __decorate([
        mobx_1.observable
    ], UpdateInventoryAudit.prototype, "delete", void 0);
    __decorate([
        mobx_1.observable
    ], UpdateInventoryAudit.prototype, "update", void 0);
    return UpdateInventoryAudit;
}());
exports.UpdateInventoryAudit = UpdateInventoryAudit;
var EditAuditBatch = /** @class */ (function () {
    function EditAuditBatch(json) {
        var _this = this;
        this.locallySaveEnteredQuantity = function (enteredQuantity) {
            _this.locallySavedEnteredQuantity = enteredQuantity;
        };
        this.id = json.id;
        this.inventoryAuditProductId = json.inventoryAuditProductId;
        this.batchId = json.batchId;
        this.batchNumber = json.batchNumber;
        this.expectedQuantity = json.expectedQuantity;
        this.enteredQuantity = json.enteredQuantity;
        this.locallySavedEnteredQuantity = json.enteredQuantity;
    }
    EditAuditBatch.prototype.setEnteredQuantity = function (quantity) {
        this.enteredQuantity = quantity;
    };
    __decorate([
        mobx_1.observable
    ], EditAuditBatch.prototype, "enteredQuantity", void 0);
    __decorate([
        mobx_1.observable
    ], EditAuditBatch.prototype, "locallySavedEnteredQuantity", void 0);
    __decorate([
        mobx_1.action
    ], EditAuditBatch.prototype, "setEnteredQuantity", null);
    __decorate([
        mobx_1.action
    ], EditAuditBatch.prototype, "locallySaveEnteredQuantity", void 0);
    return EditAuditBatch;
}());
exports.EditAuditBatch = EditAuditBatch;
//# sourceMappingURL=InventoryAudit.js.map